export const introduce = {
  text: `### 使用方法
  + 该指标统计了长期持有者持有Coin的数量，我们可以看到长期持有者总是在熊市及牛市前期增持，牛市在中后期卖出。
  
  ### 指标原理
  + 我们统计了持有大于六个月的所有投资者的持币数量，从而帮助我们判断他们的支出模式及规律。`,
  height: 1350,
};
